import React from "react";
import OmniFormGroup from "../Shared/OmniFormGroup/OmniFormGroup";
import ValidationErrors from "../Settings/ValidationErrors";

import MiscellaneousAdministration from "../../services/Management/MiscellaneousAdministration";
import DateFormatters from "../../constants/DateFormatters";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import IntlTelInput from "react-intl-tel-input";

import "react-phone-number-input/style.css";

const { ShortDateFormat } = DateFormatters;
const phoneRegExp = /^(00|\+)[1-9]{1}([0-9][\s]*){9,16}$/;

const validationSchema = Yup.object({
  dateOfBreach: Yup.date().required("Date of breach is required"),
  dateOfDiscovery: Yup.date().required("Date of discovery is required"),
  breachReporterName: Yup.string().required("Name of reporter is required"),
  reporterContactNo: Yup.string()
    .matches(phoneRegExp, "Invalid phone number format")
    .required("Contact no is required"),
  reporterEmail: Yup.string()
    .email("Contact email must be a valid email")
    .required("Contact email is required"),
  incidentOwnerName: Yup.string().required(
    "Name of incident owner is required"
  ),
  incidentOwnerContactNo: Yup.string()
    .matches(phoneRegExp, "Invalid phone number format")
    .required("Contact no of incident owner is required"),
  incidentOwnerEmail: Yup.string()
    .email("Email of incident owner must be a valid email")
    .required("Email of incident owner is required"),
  breachType: Yup.number().required("Type of breach is required"),
  locationAffected: Yup.string().required("Location affected is required"),
  descriptionOfBreach: Yup.string().required("Brief description is required"),
});

const Phone = ({ field, form }) => {
  return (
    <IntlTelInput
      onPhoneNumberChange={(...args) => {
        const phone = `+${args[2].dialCode}${args[1]}`;
        if (!form.touched[field.name]) form.setFieldTouched(field.name);
        form.setFieldValue(field.name, phone);
      }}
      preferredCountries={["gb", "be", "ie", "nl", "pl"]}
      containerClassName="intl-tel-input w-100"
      inputClassName="form-control"
      separateDialCode={true}
      nationalMode={false}
      autoHideDialCode={false}
      placeholder="7984 343 545"
      autoComplete="on"
      defaultValue={field.value ? field.value : ""}
    />
  );
};

export const Form = ({ _, sendForm }) => {
  return (
    <Formik
      initialValues={{
        dateOfBreach: "",
        dateOfDiscovery: "",
        breachReporterName: "",
        reporterContactNo: "",
        reporterEmail: "",
        incidentOwnerName: "",
        incidentOwnerContactNo: "",
        incidentOwnerEmail: "",
        breachType: "",
        locationAffected: "",
        descriptionOfBreach: "",
        affectedSubjects: "",
        descriptionOfActionTakenSinceDiscovery: "",
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        MiscellaneousAdministration.reportBreach(values)
          .then(() => {
            setSubmitting(false);
            sendForm({ sendForm: true, formValues: values });
          })
          .catch((error) => setSubmitting(false));
        sendForm(values);
      }}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        isValid,
      }) => (
        <>
          <div className="ml-3 report-breach-main">
            <div className="d-flex flex-wrap align-content-start flex-row">
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="dateOfBreach"
                  Name="dateOfBreach"
                  Type="date"
                  Placeholder="Date of Breach"
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.DateOfBreach}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.dateOfBreach}
                  onChange={(e) => {
                    setFieldValue("dateOfBreach", ShortDateFormat(e, "en"));
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.dateOfBreach}
                  message={errors.dateOfBreach}
                  _={_}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="dateOfDiscovery"
                  Name="dateOfDiscovery"
                  Type="date"
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.DateOfDiscovery}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Placeholder={_.ClientHub.FormContent.DateOfDiscovery}
                  Value={values.dateOfDiscovery}
                  onChange={(e) => {
                    setFieldValue("dateOfDiscovery", ShortDateFormat(e, "en"));
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.dateOfDiscovery}
                  message={errors.dateOfDiscovery}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="breachReporterName"
                  Name="breachReporterName"
                  Type="text"
                  Placeholder={_.ClientHub.FormContent.NameOfBreachReporter}
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.NameOfBreachReporter}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.breachReporterName}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.breachReporterName}
                  message={errors.breachReporterName}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <label>
                  {_.ClientHub.FormContent.ContactNoOfBreachReporter}{" "}
                  <span className="required"></span>
                </label>
                <Field
                  name="reporterContactNo"
                  component={Phone}
                  phoneNumber={values.reporterContactNo}
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.ContactNoOfBreachReporter}{" "}
                      <span className="required"></span>
                    </>
                  }
                  _={_}
                />
                <ValidationErrors
                  touched={touched.reporterContactNo}
                  message={errors.reporterContactNo}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="reporterEmail"
                  Name="reporterEmail"
                  Type="email"
                  Placeholder={
                    _.ClientHub.FormContent.ContactEmailOfBreachReporter
                  }
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.ContactEmailOfBreachReporter}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.reporterEmail}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.reporterEmail}
                  message={errors.reporterEmail}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="incidentOwnerName"
                  Name="incidentOwnerName"
                  Type="email"
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.NameOfIncidentOwner}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Placeholder={_.ClientHub.FormContent.NameOfIncidentOwner}
                  Value={values.incidentOwnerName}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.incidentOwnerName}
                  message={errors.incidentOwnerName}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <label>
                  {_.ClientHub.FormContent.ContactNoOfIncidentOwner}{" "}
                  <span className="required"></span>
                </label>
                <Field
                  name="incidentOwnerContactNo"
                  component={Phone}
                  phoneNumber={values.incidentOwnerContactNo}
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.ContactNoOfIncidentOwner}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Placeholder="+44 7984 343 545"
                  _={_}
                />
                <ValidationErrors
                  touched={touched.incidentOwnerContactNo}
                  message={errors.incidentOwnerContactNo}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="incidentOwnerEmail"
                  Name="incidentOwnerEmail"
                  Type="text"
                  Placeholder={
                    _.ClientHub.FormContent.ContactEmailOfIncidentOwner
                  }
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.ContactEmailOfIncidentOwner}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.incidentOwnerEmail}
                  onChange={handleChange}
                ></OmniFormGroup>{" "}
                <ValidationErrors
                  touched={touched.incidentOwnerEmail}
                  message={errors.incidentOwnerEmail}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="breachType"
                  Name="breachType"
                  Type="select"
                  Placeholder={_.ClientHub.FormContent.TypeOfBreach}
                  LabelName={
                    <>
                      {"Type of Breach "} <span className="required"></span>
                    </>
                  }
                  Value={values.breachType}
                  onChange={(e) => {
                    var index = e.nativeEvent.target.selectedIndex;
                    var selectedText = e.nativeEvent.target[index].text;

                    setFieldValue("breachTypeText", selectedText);
                    setFieldValue("breachType", e.target.value);
                  }}
                >
                  <option value="0">{_.PleaseSelect}</option>
                  <option value="1">GDPR</option>
                </OmniFormGroup>
                <ValidationErrors
                  touched={touched.breachType}
                  message={errors.breachType}
                ></ValidationErrors>
              </div>
            </div>
            <div className="d-flex align-content-start flex-column">
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="locationAffected"
                  Name="locationAffected"
                  Type="textarea"
                  Placeholder={
                    _.ClientHub.FormContent.LocationAffectedPlaceholder
                  }
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.LocationAffected}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.locationAffected}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.locationAffected}
                  message={errors.locationAffected}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="descriptionOfBreach"
                  Name="descriptionOfBreach"
                  Type="textarea"
                  Placeholder={
                    _.ClientHub.FormContent.BriefDescriptionOfBreachPlaceholder
                  }
                  LabelName={
                    <>
                      {_.ClientHub.FormContent.BriefDescriptionOfBreach}{" "}
                      <span className="required"></span>
                    </>
                  }
                  Value={values.descriptionOfBreach}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.descriptionOfBreach}
                  message={errors.descriptionOfBreach}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="affectedSubjects"
                  Name="affectedSubjects"
                  Type="textarea"
                  Placeholder={
                    _.ClientHub.FormContent.NumberOfAffectedSubjectsPlaceholder
                  }
                  LabelName={_.ClientHub.FormContent.NumberOfAffectedSubjects}
                  Value={values.affectedSubjects}
                  onChange={handleChange}
                ></OmniFormGroup>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="descriptionOfActionTakenSinceDiscovery"
                  Name="descriptionOfActionTakenSinceDiscovery"
                  Type="textarea"
                  Placeholder={
                    _.ClientHub.FormContent
                      .BriefDescriptionOfAnyActionTakenSinceDiscoveryPlaceholder
                  }
                  LabelName={
                    _.ClientHub.FormContent
                      .BriefDescriptionOfAnyActionTakenSinceDiscovery
                  }
                  Value={values.descriptionOfActionTakenSinceDiscovery}
                  onChange={handleChange}
                ></OmniFormGroup>
              </div>
            </div>
          </div>
          <div className="d-flex mt-3 grey-button justify-content-start ">
            <button
              className="d-flex ml-2 justify-content-center styled-button "
              type="submit"
              disabled={isSubmitting || !isValid}
              onClick={handleSubmit}
            >
              {_.ClientHub.FormContent.SubmitReport}
            </button>
          </div>
        </>
      )}
    </Formik>
  );
};
